import { render, staticRenderFns } from "./EditNews.page.vue?vue&type=template&id=e06dba0c&"
import script from "./EditNews.page.vue?vue&type=script&lang=js&"
export * from "./EditNews.page.vue?vue&type=script&lang=js&"
import style0 from "./EditNews.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports